import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Aria from 'formvalidation/es6/plugins/Aria';
import Twig from 'twig';

// do templatki /_blocks/list-ajax.twig
const { mainImgBtn } = JSON.parse(document.querySelector('#ajax-list-trans').innerText);
const { mainImgPreview } = JSON.parse(document.querySelector('#ajax-list-trans').innerText);
const { mainImgAuthor } = JSON.parse(document.querySelector('#ajax-list-trans').innerText);
const { mainImgHover } = JSON.parse(document.querySelector('#ajax-list-trans').innerText);
const { route } = JSON.parse(document.querySelector('#ajax-list-trans').innerText);
const trans = {
    mainImgBtn,
    mainImgPreview,
    mainImgAuthor,
    mainImgHover,
    route,
};

// do doladowywania templat
const { selectedCategory } = JSON.parse(document.querySelector('#pages').innerHTML);
const { currentPage } = JSON.parse(document.querySelector('#pages').innerHTML);
const { totalPages } = JSON.parse(document.querySelector('#pages').innerHTML);

// do przycisku apply na mobilnym filtrowaniu
const baseUrl = `https://${JSON.parse(document.querySelector('#pages').innerHTML).baseUrl}`;
const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});
const sortParam = params.order !== null && params.order === 'newest' ? '?order=newest' : '';

[].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
    const submit = form.querySelector('button[type="submit"]');
    formValidation(form, {
        plugins: {
            aria: new Aria(),
            bootstrap3: new Bootstrap3(),
            defaultSubmit: new DefaultSubmit(),
            submitButton: new SubmitButton(),
            declarative: new Declarative({
                html5Input: true,
            }),
        },
    }).on('core.form.valid', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            eventCategory: 'Forms',
            eventAction: 'Form Submitted Success',
            eventLabel: 'prior-free-trial-form',
        });
        submit.disabled = true;
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            submit.disabled = false;
        }
    });
});

// mobilne filtrowanie: otwieranie i zamykanie tabow
const mobileTabs = [].slice.call(document.querySelectorAll('.mobile-tab'));
mobileTabs.forEach((el) => {
    el.addEventListener('click', () => {
        const oldEl = document.querySelector('.mobile-tab.open');
        el.classList.add('open');
        document.querySelector('#mobile-filters').classList.add('shadow');
        if (oldEl !== null) {
            oldEl.classList.remove('open');
            if (el === oldEl) {
                document.querySelector('#mobile-filters').classList.remove('shadow');
            }
        }
    });
});

// mobilne filtrowanie: otwieranie i zamykanie filtrowania
document.querySelector('.filter-btn').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#mobile-sort').classList.remove('open');
    document.querySelector('#mobile-filters').classList.add('open');
});
document.querySelector('#close-filters').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#mobile-filters').classList.remove('open', 'shadow');
    mobileTabs.forEach((el) => {
        el.classList.remove('open');
    });
});

// mobilne filtrowanie: budowanie urla do przycisku apply
const applyFilters = document.getElementById('apply-filters');
let catUrl = selectedCategory;

// mobilne filtrowanie: pokazanie wybranej kategorii pod nazwa taba
let choosenCatTxt = document.querySelector('.mobile-categories .active').innerText.trim();

document.querySelector('.mobile-categories .choice').innerHTML = choosenCatTxt;

const allCat = [].slice.call(document.querySelectorAll('.mobile-categories li'));

// mobilne filtrowanie: zmiana wyboru kategorii
allCat.forEach((el) => {
    el.addEventListener('click', () => {
        const oldItem = document.querySelector('.mobile-categories .active');
        if (oldItem !== null) {
            oldItem.classList.remove('active');
        }
        el.classList.add('active');
        choosenCatTxt = el.innerText.trim();
        catUrl = el.dataset.slug;
        document.querySelector('.mobile-categories .choice').innerHTML = choosenCatTxt;
        applyFilters.href = `${baseUrl}/${catUrl}${sortParam}`;
    });
});

// mobilne sortowanie: otwieranie i zamykanie sortowania
document.querySelector('.sort-btn').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#mobile-filters').classList.remove('open', 'shadow');
    document.querySelector('#mobile-sort').classList.add('open');
});
document.querySelector('#close-sort').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#mobile-sort').classList.remove('open');
});

// mobilne sortowanie: zmienianie typu sortowania
const applySorting = document.getElementById('apply-sorting');
const sortingTabs = [].slice.call(document.querySelectorAll('.sort-tab'));
sortingTabs.forEach((el) => {
    el.addEventListener('click', () => {
        const oldEl = document.querySelector('.sort-tab.active');
        if (el !== oldEl) {
            oldEl.classList.remove('active');
            el.classList.add('active');
            if (el.id === 'sort-newest') {
                applySorting.href = `${window.location.href.split('?')[0]}?order=newest`;
            } else {
                applySorting.href = `${window.location.href.split('?')[0]}`;
            }
        }
        // console.log(window.location.href.split('?')[0]);
    });
});

// podglad templaty na mobilu
document.querySelector('#ajax_dest').addEventListener('click', (e) => {
    const x = window.matchMedia('(max-width: 767px)');
    if (x.matches) {
        if (e.target.tagName === 'IMG') {
            e.target.closest('.template-img').classList.add('mobile-open');
        }
        if (e.target.classList.contains('mobile-template-close')) {
            e.preventDefault();
            e.target.closest('.template-img').classList.remove('mobile-open');
        }
    }
});

// doladowywanie nowych templatpod spodem
if (currentPage < totalPages) {
    let page = 1;
    const showMoreBtn = document.querySelector('.show-more-btn');
    const ajaxWrapper = document.getElementById('ajax_dest');
    const showMore = (nextPage) => {
        const request = new XMLHttpRequest();
        const apiParams = {
            page: nextPage,
            category: selectedCategory, // 'all'
        };
        if (sortParam !== '') {
            apiParams.order = 'newest';
        }
        const encodedParams = Object.keys(apiParams).map((param) => `${encodeURIComponent(param)}=${encodeURIComponent(apiParams[param])}`);
        const langCode = /\/\/(.*)\/(..)\//.exec(document.location.href);
        let autocompleteUrl = `${langCode !== null ? `/${langCode[2]}` : ''}/api/v2/wbe/templates`;

        autocompleteUrl = autocompleteUrl.indexOf('?') === -1 ? `${autocompleteUrl}?` : `${autocompleteUrl}&`;
        request.open('GET', autocompleteUrl + encodedParams.join('&'), true);

        request.onload = () => {
            ajaxWrapper.classList.remove('loading');
            if (request.status >= 200 && request.status < 400) {
                // Success!
                const response = JSON.parse(request.responseText);
                const t = document.querySelector('script[type="template/twig"]').innerText;
                const template = Twig.twig({ data: t });
                ajaxWrapper.insertAdjacentHTML('beforeend', template.render({ response, trans }));
                /**
                 * Ukrycie btn "Show More"
                 */
                const lengthTotalPages = response.pagination.totalPages;
                const lengthCurrentPage = response.pagination.currentPage;
                if (lengthCurrentPage >= lengthTotalPages) {
                    const btn = document.querySelector('.show-more-btn');
                    btn.style.display = 'none';
                }
                /**
                 * End: // Ukrycie btn "Show More"
                 */
            } else {
                // We reached our target server, but it returned an error
            }
        };
        request.onerror = (error) => {
            // There was a connection error of some sort
            ajaxWrapper.classList.remove('loading');
            console.error(error);
        };
        request.send();
        ajaxWrapper.classList.add('loading');
    };

    showMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!ajaxWrapper.classList.contains('loading')) {
            showMore((page += 1), selectedCategory);
        }
    });
}
